import React from "react";
import BgImage from "../../components/BgImage";
import styled from 'styled-components';
import { device } from "../../Theme";
import { PrimaryButton } from "@etiquette-ui/buttons";

import useI18n from '../../i18n/useI18n';

const Regular = styled.div`
    display: block;

    @media ${device.tablet} { 
        display: none;
    }
`;
const Mobile = styled.div`
    display: none;
    
    @media ${device.tablet} { 
        display: block;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    h3 {
        margin: 0;
        padding: 0;
    }
`;

const Button = styled(PrimaryButton)`
    width: 168px;
    height: 48px;
    margin-top: 64px;

    @media ${device.laptop} {    
        margin-top: 5%;
    }
`;

const ButtonBaner = ({ data }) => {
    const { translateObject } = useI18n();
    
    return (<>
        <Regular>
            <BgImage
                title={data.banerAlt}
                fluid={data.banerImg}
            >
                <Container>
                    <h3>
                        {translateObject({
                            en: `Technology trend for your business`,
                            es: `Tecnología de vanguardia para tu empresa`
                        })}                        
                    </h3>
                    <p>
                        {translateObject({
                            en: `Contact us to take advantage of having the Digital Menu.`,
                            es: `Contáctanos para disfrutar de las ventajas de tener un menú digital.`
                        })} 
                        <br />
                        {translateObject({
                            en: `All our tools are linked to the appsinti tool to manage your business.`,
                            es: `Todas nuestras herramientas están vinculadas a la aplicación appsinti para gestionar tu negocio.`
                        })}
                    </p>
                    <Button>
                        {translateObject({
                            en: `Get it Now`,
                            es: `Lo quiero ahora`
                        })}
                    </Button>
                </Container>
            </BgImage>
        </Regular>
        <Mobile>
            <BgImage
                title={data.banerImgAltMobile}
                fluid={data.banerImgMobile}
                mobileHeight='393px'
            >
                <Container>
                    <h3>
                        {translateObject({
                            en: `Technology trend for your business`,
                            es: `Tecnología de vanguardia para tu empresa`
                        })}
                    </h3>
                    <p>
                        {translateObject({
                            en: `Contact us to take advantage of having the Digital Menu.`,
                            es: `Contáctanos para disfrutar de las ventajas de tener un menú digital.`
                        })} 
                        <br />
                        {translateObject({
                            en: `All our tools are linked to the appsinti tool to manage your business.`,
                            es: `Todas nuestras herramientas están vinculadas a la aplicación appsinti para gestionar tu negocio.`
                        })}
                    </p>
                    <Button>
                        {translateObject({
                            en: `Get it Now`,
                            es: `Lo quiero ahora`
                        })}
                    </Button>
                </Container>
            </BgImage>
        </Mobile>
    </>)
};
export default ButtonBaner;